<template>
  <div class="upload-form text-center pt-4 position-relative"> 
    <spinner v-if="loading" ></spinner>
    <server-failed-popup v-if="failed" v-model="failed"/>    
    <div class="form-wrapper rounded bg-white mx-auto pt-4 pb-5 mt-5">
      <div v-if="!complete">
        <h2 class="mt-1 mb-3">
          {{hebrew ? 'הקבצים התקבלו בהצלחה' : 'File upload successful'}}
        </h2>    
        <b-form @submit="onSubmit" class="mb-4"  ref="email-form" id="email-form" >
          <b-form-group
            id="input-group"
            :label="hebrew ? 'הזן כתובת מייל, כדי שניידע אותך בסיום העבודה' : 'Enter your email, so we can alert you when your files are ready'"
            label-for="input-email-upload"
            description=""
            class="mb-2"
            label-class="mb-4"
            valid-feedback=""
            :invalid-feedback="invalidFeedback"
            :state="state"
            >
              <b-form-input
                id="input-email-upload"
                v-model="email"
                type="text"
                placeholder=""
                @input="submitted=false"       
                class="rounded form-wrap mx-auto mt-2"
                trim
                >
              </b-form-input>
            </b-form-group>
            <b-button class="form-wrap m-auto " type="submit" variant="primary">
              {{ hebrew ? 'שלח' : 'Submit'}}
            </b-button>
          </b-form>
        </div>  
        <div v-else>
          <h2>{{hebrew ? 'הפרטים התקבלו בהצלחה' : 'Upload successful'}}</h2>
          <div class="pt-2 pb-4">{{hebrew ? 'אנו ניידע אותך בסיום העבודה' : 'We will contact you when the process is complete'}}</div>
          <i class="fas fa-check-circle mt-4"></i>
        </div>
      </div>
      <router-link v-if="complete" class="text-primary" to="/">
        <small class="mt-4 pt-2 d-block">{{hebrew ? 'חזרה לדף הבית' : 'Back to home page'}}</small>
      </router-link> 
      <router-link v-if="complete" class="text-primary" :to="'/status?id='+taskID">
        <small class="mt-4 pt-2 d-block">{{hebrew ? 'בדיקת סטטוס העלאה' : 'Check upload status'}}</small>
      </router-link> 
  </div>
</template>
<script>

import { Actions } from "@/store/stateChanges"
import { RunStates } from "@/store/runStates"
import Spinner from "@/components/spinner"
import ServerFailedPopup from "@/components/ServerFailedPopup"

export default {
  name: "EmailForm",
  data() {
    return {
      email: '',
      submitted: false,
    }
  },
  components: {Spinner, ServerFailedPopup},
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },
    state() {
      return  (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email) && this.submitted)
    },
    invalidFeedback() {
      if (this.submitted)
        return this.hebrew ? 'נא להזין כתובת מייל תקין.' : 'Please enter a valid email address.'
      return ''  
    },
    loading () {
      return this.$store.state.morphApiState === RunStates.RUNNING
    },
    complete () {
      return this.$store.state.morphApiState === RunStates.COMPLETE
    },
    taskID () {
      return this.$store.state.jobId
    },
    failed: {
      get () {
        return this.$store.state.morphApiState === RunStates.FAILED ||
        this.$store.state.morphApiState === RunStates.TIMED_OUT
      },
      set () {
        this.errorMessage = null
        this.$store.commit('MORPH_NOT_RUN')
      }
    },    
  },
  methods: {
    resetData () {

    },
    onSubmit(event) {
      event.preventDefault()
      this.submitted = true
      if (this.state) {
        this.$store.commit('SET_USER_EMAIL',  this.email)
        this.$store.dispatch(Actions.RUN_MORPH)
      }
    }
   }  
}
</script>
<style lang="scss">
  .upload-form {
    .v-spinner .v-clip {
      bottom: 10%;
      left: 48%;
      top: auto;
    }
    .form-wrapper {
      width: 507px;
      height: 311px;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
      h2 {
        font-size: 32px;  
      }
      .form-wrap {
        width: 279px;
        height: 36px;
        font-size: 16px;        
      }
      .fa-check-circle {
        font-size: 60px;
        color: #20bd05;
      }   
    }
  }
</style>
